/**
 *
 * Separator
 *
 */

import React from 'react';
import styles from './Separator.module.scss';

const Separator = () => <li className={styles.drawerSeparator} />;

export default Separator;
